import { useSelector } from 'react-redux';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { type RootState } from '../../stores/redux';
import { clearTriggerElementId } from '../../features/modals/modals.slice';

export const useRestoreModalFocus = (): void => {
  const dispatch = useDispatch();
  const { current, triggerElementId } = useSelector(
    (state: RootState) => state.modals,
  );

  useEffect(() => {
    if (current === null && triggerElementId) {
      requestAnimationFrame(() => {
        // Restore focus to the trigger element
        const el = document.getElementById(triggerElementId);
        el?.focus();

        dispatch(clearTriggerElementId());
      });
    }
  }, [current, triggerElementId, dispatch]);
};
